export default __webpack_public_path__ + "static/media/cross-btn.2e9a70f7.svg";